import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { PackagingType } from 'src/app/core/interfaces/packagingType';
import { Utils } from 'src/app/core/resources/utils';
import { ModelCargo } from '../../manual-creation-cargo/resources/modelCargo';

@Component({
  selector: 'app-packaging-type-field',
  templateUrl: './packaging-type-field.component.html',
  styleUrls: ['./packaging-type-field.component.scss'],
  providers: [ModelCargo]
})
export class PackagingTypeFieldComponent implements OnInit {

  @Input() inputFormGroup: FormGroup;
  public listPackagingTypes: PackagingType[] = this.modelCargo.packagingTypes.filter(pack => !pack.hidden);

  constructor(
    public utils: Utils,
    private modelCargo: ModelCargo
  ) { }

  ngOnInit() {
  }

  public onSelect($event): void {
    console.log($event);
  }
}
